import { client } from './client';

const { VITE_AEM_URL } = import.meta.env;

export const getHeaderConfig = ({ requestConfig }) => {
  return client(
    `header-configuration/jcr:content.data.json`,
    {
      ...requestConfig,
      withCredentials: false,
      method: 'GET'
    },
    VITE_AEM_URL
  );
};
